<template>
  <div class="content">
    <div class="header">
      <van-nav-bar title="支付结果" />
    </div>
    <div class="center" v-show="content">
      <div class="result">
        <img src="../../assets/img/duihao.png" alt="" />
      </div>
      <div class="results">
        <span>{{ orderStatus }}</span>
      </div>
      <p>实付:￥{{ Number(this.$store.getters.getProcuctMoney).toFixed(2)}}</p>
      <div class="selectBtn">
        <van-button type="default" @click="toIndex">返回首页</van-button>
        <van-button
          class="select"
          @click="$router.replace('/myOrder2')"
          type="default"
          >查看订单</van-button
        >
      </div>
    </div>
    <van-loading
      v-show="LoadingShow"
      type="spinner"
      size="1rem"
      vertical
      >加载中</van-loading
    >
  </div>
</template>
<script>
import checkDevice from "../../tools/app";
export default {
  data() {
    return {
      content: false,
      LoadingShow: true,
      orderStatus: "",
      orderCode: sessionStorage.getItem("PRODUCT_NUMBER"),
    };
  },
  created() {
    // 用来让安卓和ios调用传递token和userId的方法 str接收
    window["callJsFunction"] = this.callJsFunction;
  },
  mounted() {
    this.getOrderStatus();
  },
  methods: {
    // 传过来token和userId的回调
    callJsFunction(str) {
      // 判断设备系统的函数
      let phone = checkDevice();
      if (phone == "ios") {
        sessionStorage.setItem("CONFIDENTIAL", str);
        let exclusive = str.slice(37);
        sessionStorage.setItem("EXCLUSIVE", exclusive);
      } else {
        sessionStorage.setItem("CONFIDENTIAL", str);
        let exclusive = str.slice(33);
        sessionStorage.setItem("EXCLUSIVE", exclusive);
      }
    },
    // 获取支付结果
    getOrderStatus() {
      let count = 0;
      let time = window.setInterval(async () => {
        if (40 == count) {
          window.location.reload();
        }
        count++;
        this.$post({
          url: "/oor/findOrderDetailByOrderCode",
          methods: "post",
          params: {
            orderCode: this.orderCode,
          },
        })
          .then((res) => {
            if (res.retCode == 200) {
              if (res.data.order_status !== 0 && res.data.order_status !== -1) {
                window.clearInterval(time);
                this.orderStatus = "支付成功";
                this.content = true;
                this.LoadingShow = false;
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }, 2000);
    },
    // 跳转首页
    toIndex() {
      this.$router.replace("/index");
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  position: relative;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #ffff;
    /deep/.van-nav-bar {
      background-color: #40000000;
      .van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          margin-top: 0.1rem;
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 500 !important;
      }
    }
  }
  .center {
    height: 100%;
    overflow: hidden;
    .result {
      margin-top: 3rem;
      text-align: center;
      img {
        vertical-align: middle;
        width: 1.5rem;
        height: 1.5rem;
      }
      span {
        margin-left: 0.2rem;
        font-size: 0.52rem;
      }
    }
    .results {
      margin-top: 0.2rem;
      text-align: center;
      img {
        vertical-align: middle;
        width: 1.5rem;
        height: 1.5rem;
      }
      span {
        font-size: 0.62rem;
      }
    }
    p {
      margin-top: 0.2rem;
      text-align: center;
      font-size: 0.44rem;
      color: red;
    }
    .selectBtn {
      margin-top: 1rem;
      text-align: center;
      .van-button {
        margin: 0;
        padding: 0;
        width: 3rem;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.34rem;
        border-radius: 0.5rem;
      }
      .select {
        margin-left: 1rem;
      }
    }
  }
  .van-loading {
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
